
<div class="p-3 flex flex-column flex-auto">
  <div class="flex align-items-center justify-content-between mb-3">
    <div class="text-900 font-medium text-xl"><h3>Manage Waiver</h3></div>
    <button pButton type="button" class="p-button p-button-sm p-button-outlined"
      (click)="returnToBookingBlock()"
      pTooltip="Return to Booking List">
      <span class="pi pi-arrow-left" style="margin-right:8px;"></span>
      <span>Return to Booking List</span>
    </button>
  </div>

  <div class="surface-card p-4 shadow-2 border-round">
    <div class="booking-info-enhanced">
      <div class="booking-header">
        <i class="pi pi-calendar" style="font-size: 1.5rem; color: #3B82F6;"></i>
        <h4 class="booking-title">Booking Information</h4>
      </div>

      <div class="info-grid">
        <div class="info-card">
          <div class="info-icon">
            <i class="pi pi-clock" style="color: #10B981;"></i>
          </div>
          <div class="info-content">
            <div class="info-label">Booking Date</div>
            <div class="info-value">{{ bookingDate | date:'dd/MM/yyyy HH:mm' }}</div>
          </div>
        </div>

        <div class="info-card">
          <div class="info-icon">
            <i class="pi pi-box" style="color: #8B5CF6;"></i>
          </div>
          <div class="info-content">
            <div class="info-label">Package</div>
            <div class="info-value">{{packageName}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <br>

    <!-- Responsive container for MainContent and SideBar -->
    <div class="content-layout" style="margin-top:20px;">
      <div id="MainContent" class="surface-card p-4 shadow-2 border-round main-content">

        <div class="card-header">
          <button pButton type="button" class="p-button p-button-sm p-button-outlined"
            (click)="refreshData()"
            pTooltip="Refresh Data"
            style="margin-right: -750x;">
            <span class="pi pi-refresh"></span>
          </button>

          <h3>Participants</h3>
          <div class="waiver-status">
            <div class="status-text">
              <span>Waivers Signed</span>&nbsp;
              <span>{{ totalWaiversSigned }} / {{ totalParticipants }}</span>
            </div>
            <div class="progress-bar-container">
              <div class="progress-bar-fill" style="width: {{ (totalWaiversSigned / totalParticipants) * 100 }}%"></div>
            </div>
          </div>
        </div>

        <p-table [value]="waivers">
          <ng-template #header>
            <tr>
              <th style="width:50%">Participant Name</th>
              <th style="width:10%">Adult</th>
              <th style="width:10%">Minor</th>
              <th style="width:10%">Participant</th>
              <th style="width:20%"></th>
            </tr>
          </ng-template>
          <ng-template #body let-waiver>
            <tr>
              <td>{{ waiver.name }}</td>
              <td>
                @if (waiver.adult) {
                  <span style="color:green" class="pi pi-check-circle"></span>
                }
                @if (!waiver.adult) {
                  <span>-</span>
                }
              </td>
              <td>
                @if (waiver.minor) {
                  <span style="color:green" class="pi pi-check-circle"></span>
                }
                @if (!waiver.minor) {
                  <span>-</span>
                }
              </td>
              <td>
                @if (waiver.participant) {
                  <span style="color:green" class="pi pi-check-circle"></span>
                }
                @if (!waiver.participant) {
                  <span>-</span>
                }
              </td>
              @if (waiver.adult) {
                <td>
                  <button pButton type="button" class="p-button p-button-sm p-button-outlined"
                    (click)="changeParticipant(waiver)"
                    pTooltip="Switch Participant">
                    <span class="pi pi-sync" style="margin-right:8px;"></span>
                    <span>Switch Participant</span>
                  </button>
                </td>
              }
              @if (!waiver.adult) {
                <td>
                  <button disabled="true" pButton type="button" class="p-button p-button-sm p-button-outlined"
                    pTooltip="Switch Participant">
                    <span class="pi pi-sync" style="margin-right:8px;"></span>
                    <span>Switch Participant</span>
                  </button>
                </td>
              }
            </tr>
          </ng-template>
        </p-table>

        <br>
        </div>

        <div id="SideBar" class="surface-card p-4 shadow-2 border-round actions-card sidebar">

          <h3>Quick Actions</h3>

          <div class="action-section">
            <button pButton type="button" class="p-button p-element p-ripple p-button-success p-button p-component" style="width:100%;" [disabled]="!isBookingDateToday" (click)="admitall(this.id)">
              <span class="pi pi-sign-in" style="margin-right:8px;"></span>
              <span>Admit</span>
            </button>
          </div>

          <div class="action-section">
            <div>Send Waiver to Customer</div>

            <input id="prefix" [(ngModel)]="emailAddress" type="text" pInputText placeholder="customer@example.com" style="width: 100%;margin-bottom:20px;">
            @if (!emailAddressValid) {
              <div class="text-danger" Style="margin-left:10px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>Your must enter an Email Address.</div>
            }

            <br>
              <button pButton type="button" class="p-button p-element p-ripple p-button-success p-button p-component" style="width:100%;" (click)="sendWaiverLinkEmail();">
                <span class="pi pi-envelope" style="margin-right:8px;"></span>
                <span>Send Link to Email above</span>
              </button>
            </div>

            <div class="divider"></div>

            <div class="action-section">
              <div>Send Confirmation Email</div>
              <button pButton pRipple type="button" class="p-button-success p-element p-button w-auto mt-3" style="margin-bottom:20px;width:100% !important;" (click)="sendEmailConfirmation()">
                <span class="pi pi-envelope" style="margin-right:8px;"></span>
              Send Confirmation Email</button>
            </div>

            <div class="divider"></div>

            <div class="action-section">
              <div>Magic Number</div>
              <p style="color: #64748b; font-size: 0.9rem; margin-bottom: 1rem;">
                Give this number to your customer to allow them to sign a waiver for this booking.
              </p>

              <div class="link-box">
                @if (!magicNumberExists) {
                  <button pButton type="button" class="p-button p-element p-ripple p-button-warn p-button p-component" style="width: 100%;" (click)="createMagicNumber();">
                    <span class="pi pi-copy" style="margin-right:8px;"></span>
                    <span>Create Magic Number</span>
                  </button>
                }

                @if (magicNumberExists) {
                  <div class="magic-number-box" style="text-align:center; font-weight:bold; font-size:50px;">
                    {{ magicNumber }}
                  </div>
                }
              </div>
            </div>
          </div>
        </div>

      </div>
